<template>
  <card-modal :visible="true" :title="title" :showPreview="false" :okText="'Confirmar'" :disableOk="false">
    <div id="modal-edit-content" class="content">
      <span class="icon is-large modal-center-icon">
        <i class="fa fa-exclamation-triangle"></i>
      </span>
      <div class="has-text-centered">{{ warningText }}</div>
    </div>
  </card-modal>
</template>

<script>
import CardModal from '../Util/CardModal'

export default {
  components: {
    CardModal
  },

  props: {
    title: String,
    panoramaId: Number,
    id: Number,
    warningText: String,
    type: String
  },

  data () {
    return {
      showPreview: false
    }
  },

  computed: {
    currentEvent () {
      return window.store.state.event.nextEvent
    }
  },

  methods: {
  },

  watch: {
    currentEvent: function (val) {
      if (val === 'modal-card-close') {
        this.$destroy()
      }
      if (val === 'modal-card-ok') {
        // window.store.dispatch('deleteUser', this.id)
        if (this.type === 'hotspot') {
          window.store.dispatch('deletePanoramaPoint', this.id)
        }
        if (this.type === 'cube') {
          window.store.dispatch('deletePanoramaCube', {position: this.id, panoramaId: this.panoramaId})
        }
        window.store.dispatch('newEvent', 'modal-card-close')
      }
      if (val === 'modal-card-cancel') {
        window.store.dispatch('newEvent', 'modal-card-close')
      }
    }
  }
}
</script>

<style>
  .modal-center-icon {
    width: 100% !important;
  }
</style>


// WEBPACK FOOTER //
// PanoramaDeleteModal.vue?14a72121